function waitForElm(selector) {
	return new Promise((resolve) => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver((mutations) => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
}

$(function () {
	waitForElm('#Avada-SC-modal').then((elm) => {
		if ($('#avada-modal-content table + table').length > 0) {
			$('#avada-modal-content table + table').each(function () {
				$(this).prev('table').addBack().wrapAll('<div id="avada_table_tabs"/>');

				var avada_table_tabs = `
            <input type="radio" name="avada-tab" id="avada-tab-cm" checked>
            <input type="radio" name="avada-tab" id="avada-tab-inch">
            <div>
              <label for="avada-tab-cm">CENTIMETERS</label>
              <label for="avada-tab-inch">INCHES</label>
            </div>
          `;
				$('#avada_table_tabs').prepend(avada_table_tabs);
			});
		}
	});
});

sessionStorage.setItem('previousProductPage', window.location.href)